import React from 'react';
import { View, Text, FlatList } from 'react-native';

interface StateHistoryListProps {
  historyData: any[];
  title: string;
}

/**
 * Renders a list of state history items.
 * @param {historyData} - The array of historical states to display.
 * @param {title} - The title to display for each item in the list.
 */
const StateHistoryList: React.FC<StateHistoryListProps> = ({ historyData, title }) => {
  // Don't render anything if there's no data
  if (!historyData || historyData.length === 0) {
    return null;
  }

  return (
    <View style={{ minHeight: "70vh", gap: 5, flex: 1, backgroundColor: 'transparent' }}>
      <FlatList
        data={historyData}
        contentContainerStyle={{ gap: 10, maxHeight: 600, padding: 5 }}
        renderItem={({ item, index }) => (
          <View key={index} style={{ borderRadius: 5, backgroundColor: 'white', paddingVertical: 10 }}>
            <Text adjustsFontSizeToFit style={{ fontSize: 11, textAlign: 'center' }}>
              {title}
            </Text>
          </View>
        )}
        keyExtractor={(item, index) => `history-${title}-${index}`}
      />
    </View>
  );
};

export default React.memo(StateHistoryList);